import * as React from 'react';
import PropTypes from 'prop-types';
import { MonthlyPresenceTableTds } from './MonthlyPresenceTableTds';
import classNames from 'classnames';
import TableSort from '../../../../../shared/components/TableSort';
import { I18nUtils } from '../../../../../../i18n/I18nUtils';
import { CSSFixedColumns } from './CssFixedColumns';
import { MonthlyPresenceSorting } from '../../MonthlyPresenceSorting';
import './MonthlyPresenceTable.css';

export class MonthlyPresenceTable extends React.Component {

    render() {
        const {
            sorting,
            presences,
            onSortByColumn,
        } = this.props;

        if (!presences || presences.length === 0) {
            return (
                <h4 className={'text-center'}>
                    {I18nUtils.tr('TR_NO_HAY_PRESENCIAS')}
                </h4>
            )
        }

        return (
            <div className={'listeria'}>
                <table className={'table listeria-table'}>
                    <thead>
                    <tr>
                        <th className={'monthly-table-columns-component fixed-th'}>
                            <TableSort
                                id={MonthlyPresenceSorting.WORKER_DNI}
                                asc={sorting.isColumnOrientationAsc(MonthlyPresenceSorting.WORKER_DNI)}
                                selected={sorting.isColumnSelected(MonthlyPresenceSorting.WORKER_DNI)}
                                label={I18nUtils.tr('TR_DNI_NIF')}
                                className="fixed-pseudo-th"
                                style={CSSFixedColumns.WORKER_DNI}
                                onSort={onSortByColumn}
                            />
                            <TableSort
                                id={MonthlyPresenceSorting.WORKER_NAME}
                                asc={sorting.isColumnOrientationAsc(MonthlyPresenceSorting.WORKER_NAME)}
                                selected={sorting.isColumnSelected(MonthlyPresenceSorting.WORKER_NAME)}
                                label={I18nUtils.tr('TR_TRABAJADOR')}
                                className="fixed-pseudo-th"
                                style={CSSFixedColumns.WORKER_NAME}
                                onSort={onSortByColumn}
                            />
                            <TableSort
                                id={MonthlyPresenceSorting.WORKER_COMPANY}
                                asc={sorting.isColumnOrientationAsc(MonthlyPresenceSorting.WORKER_COMPANY)}
                                selected={sorting.isColumnSelected(MonthlyPresenceSorting.WORKER_COMPANY)}
                                label={I18nUtils.tr('TR_SUBCONTRATA')}
                                className="fixed-pseudo-th"
                                style={CSSFixedColumns.WORKER_COMPANY}
                                onSort={onSortByColumn}
                            />
                        </th>
                        {this.renderDays()}
                    </tr>
                    </thead>
                    <tbody>
                    {
                        presences.map((presence, index) => {
                            return (
                                <tr key={index}>
                                    <MonthlyPresenceTableTds worker={presence.worker}/>
                                    {
                                        this.renderDaysWork(presence.days)
                                    }
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    }

    renderDays = () => {
        const { days } = this.props;

        return days.map((day, index) => {
            const isWorkDay = day.is_work_day;
            const dayClassName = classNames(
                'th-day',
                { 'weekend': !isWorkDay },
            );
            return (
                <th key={index}
                    className={dayClassName}>
                    {day.day_of_month}
                </th> );
        });
    };

    renderDaysWork = (presenceDays) => {
        const { days } = this.props;

        return days.map((day, i) => {
            const isWorkDay = !day.is_work_day;
            const isChecked = presenceDays.includes(day.day_of_month);
            const tdClassName = classNames(
                { 'weekend': isWorkDay },
                { 'checked-cell': isChecked },
                { 'unchecked-cell': !isChecked },
            );

            return (
                <td key={i}
                    className={tdClassName}>
                    {isChecked ? <i className="material-icons">done</i> : null}
                </td>
            );
        });
    };
}

MonthlyPresenceTable.propTypes = {
    days: PropTypes.array,
    sorting: PropTypes.object,
    presences: PropTypes.array,
    tableClass: PropTypes.string,
    onSortByColumn: PropTypes.func,
};

MonthlyPresenceTable.defaultProps = {
    days: [],
    presences: [],
    tableClass: '',
    columnSortedSelected: '',
};




// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/components/table/MonthlyPresenceTable.jsx